import { render, staticRenderFns } from "./ScenicArea.vue?vue&type=template&id=5335a6b1&scoped=true&"
import script from "./ScenicArea.vue?vue&type=script&lang=js&"
export * from "./ScenicArea.vue?vue&type=script&lang=js&"
import style0 from "./ScenicArea.vue?vue&type=style&index=0&id=5335a6b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335a6b1",
  null
  
)

export default component.exports